import BackgroundSection from "./backgroundSection/BackgroundSection";
import ContactUsSection from "./contactUsSection/ContactUsSection";
import MapSection from "./mapSection/MapSection";
import FeedbackSection from "./ feedbackSection/FeedbackSection";

const ContactsPage = () => {
    return (
        <div>
            <BackgroundSection/>
            <ContactUsSection/>
            <MapSection/>
            <FeedbackSection/>
        </div>
    )
}
export default ContactsPage;